import React, { useState } from 'react';

import { Text } from 'components';

import { useContactState } from './hooks';
import ContactTypeSelect from './ContactTypeSelect';
import {
  EmailInput,
  EmailInputValueType,
  PhoneInput,
  PhoneInputValueType,
  RequiredInput,
  MustCallWarning,
} from './components';
import {
  StyledDetailInputsContainer,
  StyledDetailSectionContainer,
} from './styled';

type ConciergeInputsProps = {
  disabled: boolean;
};

const ConciergeInputs: React.FC<ConciergeInputsProps> = ({ disabled }) => {
  const [contactState, updateContactState, errors] = useContactState();
  const { firstName, phone, email, deliveries } = contactState;

  const [showEmailInput, setShowEmailInput] = useState(Boolean(email));

  const handleOnNameChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    const newName = e.target.value;
    updateContactState({ firstName: newName });
  };

  const handleOnPhoneChange = (value: PhoneInputValueType) => {
    updateContactState({ phone: [value] });
  };

  const handleOnEmailChange = (value: EmailInputValueType) => {
    updateContactState({
      email: value.email,
      deliveries: {
        Email: value.sendEmail,
      },
    });
  };

  return (
    <StyledDetailSectionContainer>
      <StyledDetailInputsContainer>
        <ContactTypeSelect />
      </StyledDetailInputsContainer>
      {disabled ? (
        <Text type="danger">Please add only one concierge per listing.</Text>
      ) : (
        <>
          <RequiredInput
            label="Contact / Building Name"
            value={firstName}
            onChange={handleOnNameChange}
            error={errors.firstName}
            data-cy="edit-contact-input-firstname"
          />
          <PhoneInput
            label="Phone"
            value={phone[0]}
            onChange={handleOnPhoneChange}
            phoneNumberMask
            error={errors.phone[0]}
            dataCy="edit-contact-input-phone"
          />
          <MustCallWarning />
          {showEmailInput ? (
            <EmailInput
              value={{
                email,
                sendEmail: deliveries.Email,
              }}
              onChange={handleOnEmailChange}
              error={errors.email}
              dataCy="edit-contact-email"
            />
          ) : (
            <div onClick={() => setShowEmailInput(true)}>+ Add Email</div>
          )}
        </>
      )}
    </StyledDetailSectionContainer>
  );
};

export default ConciergeInputs;
